var map = {
	"./Band/index.tsx": 3138,
	"./Check/index.tsx": 3093,
	"./Gauge/index.tsx": 3139,
	"./Graph/index.tsx": 3146,
	"./Heatmap/index.tsx": 3147,
	"./Histogram/index.tsx": 3148,
	"./Map/index.tsx": 3121,
	"./Mosaic/index.tsx": 3149,
	"./Scatter/index.tsx": 3140,
	"./SimpleTable/index.tsx": 3175,
	"./SingleStat/index.tsx": 3150,
	"./SingleStatWithLine/index.tsx": 3151,
	"./Table/index.tsx": 3126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1992;